import { createApiActionTypes } from '../../helpers/actions';

export const EVENTS_SHOW = createApiActionTypes('EVENTS_SHOW');
export const EVENTS_LATEST = createApiActionTypes('EVENTS_LATEST');
export const EVENTS_TICKETS = createApiActionTypes('EVENTS_TICKETS');
export const EVENTS_TICKETS_CURATED = createApiActionTypes('EVENTS_TICKETS_CURATED');


// WEBPACK FOOTER //
// ./src/actions/events/types.js